import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { trackEvent } from "@/lib/api";

export default function PaymentCancel() {
  useSeo({ title: "Checkout Canceled | Infant Sleep Clarity", noindex: true });
  const nav = useNavigate();
  useEffect(() => {
    let product = "";
    try { product = localStorage.getItem("isc_pending_product") || ""; } catch (e) {}
    trackEvent("checkout_abandoned", { product_id: product });
  }, []);
  return (
    <div className="min-h-screen bg-[#F9F8F6] grid place-items-center px-5">
      <div className="max-w-md w-full bg-white border border-[#E5E1D8] rounded-2xl p-10 text-center">
        <h1 className="font-display text-2xl text-[#1A1918]">Checkout canceled</h1>
        <p className="text-[#6B665E] mt-3 text-sm leading-relaxed">No charge was made. Whenever you're ready, you can pick up right where you left off — there's no need to decide everything at once.</p>
        <button onClick={() => nav("/")} className="mt-7 w-full py-3 rounded-full bg-[#9F634E] hover:bg-[#8C5441] text-white text-sm transition-colors">Back to home</button>
      </div>
    </div>
  );
}
